import { render, staticRenderFns } from "./PageTemplate.vue?vue&type=template&id=d31efd1a&scoped=true"
import script from "./PageTemplate.vue?vue&type=script&lang=js"
export * from "./PageTemplate.vue?vue&type=script&lang=js"
import style0 from "./PageTemplate.vue?vue&type=style&index=0&id=d31efd1a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d31efd1a",
  null
  
)

export default component.exports